import React, {FC} from "react"

/*
    <WithLoading loading={loading}>
        ...
    <WithLoading/>
 */

interface WithLoadingProps { loading: boolean }

export const WithLoading: FC<WithLoadingProps> = ({ loading, children }) =>
    <> {loading ? 'Loading...' : children} </>

    // export const withLoading = <P extends object>(Component: React.ComponentType<P>) =>
//     class WithLoading extends React.Component<P & WithLoadingProps> {
//         render() {
//             const { loading, ...props } = this.props;
//             return loading ? <div>Loading...</div> : <Component {...props as P} />
//         }
//     }


// export const withLoading2 = <P extends object>( Component: React.ComponentType<P> ): 
//         React.FC<P & WithLoadingProps> => ({ loading, ...props }: WithLoadingProps) =>
//     loading ? <div>Loading...</div> : <Component {...props as P} />;

